var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "magnify") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clients-02",
    transform: "translate(-1290.000000, -121.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1270.000000, 104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(20.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5168,15.99744 C15.3888,15.99744 15.26784,15.94752 15.1776,15.85664 L11.008,11.6864 C10.52096,12.10304 9.97248,12.44288 9.37408,12.69696 C8.58752,13.03104 7.76128,13.20064 6.9184,13.20064 C6.11392,13.20064 5.32352,13.0464 4.56768,12.74112 C3.01184,12.11328 1.79392,10.91776 1.13792,9.37344 C0.48192,7.82976 0.46592,6.12224 1.09376,4.56704 C1.7216,3.01184 2.91712,1.79328 4.4608,1.13728 C5.24736,0.80256 6.07296,0.6336 6.91648,0.6336 C7.72096,0.6336 8.51136,0.78848 9.2672,1.09312 C10.82304,1.72096 12.04096,2.91648 12.69696,4.4608 C13.35296,6.00512 13.36896,7.712 12.74112,9.2672 C12.48384,9.90464 12.12928,10.48896 11.68576,11.00672 L15.85664,15.17824 C16.04352,15.36512 16.04352,15.66976 15.85664,15.85728 C15.76576,15.94752 15.6448,15.99744 15.5168,15.99744 Z M6.91648,1.5936 C6.20288,1.5936 5.50272,1.73696 4.83648,2.02048 C3.52832,2.57664 2.5152,3.60832 1.98336,4.92608 C1.45152,6.24384 1.46496,7.6896 2.02048,8.99776 C2.57664,10.30592 3.60832,11.31904 4.92608,11.85088 C5.56672,12.10944 6.2368,12.24 6.91776,12.24 C7.63136,12.24 8.33152,12.09664 8.99776,11.81312 C9.62112,11.54816 10.17984,11.1744 10.65792,10.70208 C10.66432,10.69312 10.67136,10.68544 10.6784,10.6784 C10.68864,10.66816 10.69824,10.65984 10.7072,10.65344 C11.19552,10.16 11.58336,9.56992 11.85024,8.90752 C12.38208,7.58976 12.36864,6.144 11.81248,4.83584 C11.25696,3.52768 10.22464,2.51456 8.90688,1.98272 C8.26752,1.7248 7.59744,1.5936 6.91648,1.5936 Z",
    id: "magnify"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnify);
export default __webpack_public_path__ + "static/media/magnify.65fc7fa74f9758600a48830422e41cbb.svg";
export { ForwardRef as ReactComponent };